<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { RelationshipOptions,dateToWords } from "./store.js";
  import wrappedFetch from '../../wrappedfetch.js';
  export let applicationId;
  export let childId;
  let address;  
  let applicant;
  let applicantAddress;
  let schools = [];
  let selectedPrefs = 0;
  let isInfo = false;
  let isSuppInfo = false;
  let laAnswers = '';
  let applicantPhones = [];
  let getApplicationPromise;
  let showDetails = false;
  const dispatch = new createEventDispatcher();
  const ordinal = number => {
    var suffix = "th";
    var hr = number % 100;
    var tr = number % 10;
    if ((hr != 11 && hr != 12) || hr != 13) {
      if (tr == 1) {
        suffix = "st";
      } else if (tr == 2) {
        suffix = "nd";
      } else if (tr == 3) {
        suffix = "rd";
      }
    }
    return number + suffix;
  };
  
  const isYes = (v) =>
  v === true || v === 1 || v === '1' || v === 'Y' || v === 'y';

  const getChild =async () => {
    let response =  await wrappedFetch(
      `/child/getchildren?childId=${childId}&x=${new Date().getTime()}`
    ).then(response => response.json());
    return response.children;
  };

  onMount(async()=>{
     await getChild().then(result => {    
    let application = result[0].applications.filter(
      a => a.applicationId == applicationId
    );
    if(application.length == 0 || !application[0].isApplicationViewable)
    {
      dispatch('pageRedirect',{url:'/user/home/'});
    }
    else{

      showDetails = true;
    }
  });
  })
    
  
  
  const parseDate = dateStr => {
    let dt = dateStr.split("-");
    return dt[2]+"/"+dt[1]+"/"+dt[0];
  //  let d = new Date(dateStr);
  //   return (
  //     (d.getDate() < 10 ? "0" + d.getDate() : d.getDate()) +
  //     "/" +
  //     (d.getMonth() < 9 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1) +
  //     "/" +
  //     d.getFullYear()
  //   );
  };
  const getAddressDetail = address => {
    let addressStr = "";
    if(address){
    let saon = address.SAON && address.SAON != ""? address.SAON.replace(" ", ""):'';
    let paon = address.PAON && address.PAON != ""? address.PAON.replace(" ", ""):'';
    if (saon!= "")
      addressStr += saon+"<br/>";
    if (paon != "")
      addressStr += paon + (saon != '' ?"<br/>":'');
    if (address.Street && address.Street != "")
      addressStr += address.Street + "<br/>";
    if (address.Locality && address.Locality != "")
      addressStr += address.Locality + "<br/>";
    if (address.Town && address.Town != "")
      addressStr += address.Town + "<br/>";
    if (address.PostTown && address.Town && address.PostTown !=  address.Town)
      addressStr += address.PostTown + "<br/>";
    if (address.PostCode && address.PostCode != "")
      addressStr += address.PostCode + "<br/>";
    }
    return addressStr;
  };
  const getGenderDetails = gender => {
    if (gender == "M") return "Boy";
    else if (gender == "F") return "Girl";
    else return "";
  };
  const getSecondContactFirstName = contactDetails => {
    let n = "";
    contactDetails.split(";").forEach(e => {
      if (e.split("=")[0] == "scforename") n = e.split("=")[1];
    });
    return n;
  };
  const getSecondContactSurName = contactDetails => {
    let n = "";
    contactDetails.split(";").forEach(e => {
      if (e.split("=")[0] == "scsurname") n = e.split("=")[1];
    });
    return n;
  };
  const getSecondContactRelation = contactDetails => {
    let n = "";
    contactDetails.split(";").forEach(e => {
      if (e.split("=")[0] == "screl") n = e.split("=")[1];
    });
    return RelationshipOptions.find(r => r.value == n).label;
  };
  const getLatestApplication = async () => {
    return wrappedFetch(
      "child/GetApplicationLatestVersion?applicationid=" + applicationId,
      { method: "post" }
    )
      .then(response => response.json())
      .then(result => { 
        /* let details = result;
        laUrl = details.laUrl;
        laName = details.laDisplayName; */
        address = result.application.Address.BS7666Address;
        applicant = result.application.Applicant;
        if (!applicant.Address.AddressAsPupil)
          applicantAddress = applicant.Address.BS7666Address;
        let preferences = result.application.Preferences;

if(result.application.Applicant.Phones)
        Object.keys(result.application.Applicant.Phones).forEach(phone => {
          applicantPhones.push({TelephoneType:result.application.Applicant.Phones[phone].TelephoneType,PhoneNo :result.application.Applicant.Phones[phone].PhoneNo}); 
        });
       

        schools = [];
        Object.keys(preferences).forEach(pref => {
          schools.push(preferences[pref].school);
           
          if(preferences[pref].LEAspecificInformation && laAnswers == '')
          {
          
          laAnswers = preferences[pref].LEAspecificInformation.LEAtext ?  preferences[pref].LEAspecificInformation.LEAtext : '';
          }
          selectedPrefs++;
        });
          isSuppInfo = schools.some(s => s.warningText &&  s.warningText !="");
     
        isInfo = schools.some(s => s.information && s.information !="");
        
        return result;
      });
  };
</script>

<svelte:head>
  <title>Application Details | eAdmissions</title>
</svelte:head>
{#if showDetails}
{#await getLatestApplication() then details}
  <section class="section">
    <div class="container">
      <div class="columns is-centered is-desktop">
        <div class="column is-10-desktop">

          <div class="step-13-shows" style="word-break:break-word;">
            <div class="field">
              <a href="/user/home">
                <span class="fas fa-arrow-left" />
                Back
              </a>
            </div>
            <h1 class="title is-3">Application details</h1>
            <p><b>{details.phaseInformationDetails}</b></p>
            <nav class="panel" style="margin-top: 15px;" tabindex="0">
              <div
                class="panel-heading "
                style="display: flex;align-items: stretch;font-size: inherit;">
                <strong>Application details</strong>
               
              </div>

              <div class="panel-block">
                <div class="column">
                  <div class="field">
                   
                      Application reference:
                       <strong>
                      <span>{details.application.ApplicationReference}</span>
                    </strong>
                  </div>
                  <div class="field">                   
                      Version Number:
                       <strong>
                      <span>{details.version}</span>
                    </strong>
                  </div>
                  <div class="field">
                   
                      Application date:
                       <strong><span>{details.strApplicationDate}</span>
                    </strong>
                    <br />                   
                      Closing date:
                       <strong><span>{details.strClosingDate}</span>
                    </strong>
                    <br />                    
                      Outcome date:
                      <strong><span>{details.strOutcomeDate}</span>
                    </strong>
                  </div>
                </div>
              </div>
            </nav>
            {#if details.phaseInfo && details.phaseInfo != ''}
              <nav class="panel" style="margin-top: 15px;"  tabindex="0">
                <div
                  class="panel-heading"
                  style="display: flex;align-items: stretch;font-size: inherit;">
                  <strong>  {@html details.phaseName}</strong>
                </div>

                <div class="panel-block" style="display: block;overflow-wrap: break-word;word-wrap: break-word;">
                
                    {@html details.phaseInfo}
                 
                </div>
              </nav>
            {/if}

            {#if isInfo}
              <nav class="panel" style="margin-top: 15px;"  tabindex="0">
                <div
                  class="panel-heading"
                  style="display: flex;align-items: stretch;font-size: inherit;">
                  <strong>Important School Information</strong>
                </div>

                <div class="panel-block">
                  <div class="column">
                    The following school(s) have important school information.<br/><br/>
                    {#each schools as s}
                      {#if s.information && s.information != ''}
                        <strong>
                          <p>
                          {s.schoolName}
                            <br />
                            {@html s.information}
                            <br/>
                          </p>
                        </strong>
                      {/if}
                    {/each}
                  </div>
                </div>
              </nav>
            {/if}
            {#if isSuppInfo}
              <nav class="panel" style="margin-top: 15px;"  tabindex="0">
                <div
                  class="panel-heading"
                  style="display: flex;align-items: stretch;font-size: inherit;">
                  <strong>Supplementary Information Forms</strong>
                </div>

                <div class="panel-block">
                  <div class="column">
                    The following school(s) require a Supplementary information
                    form, which can be obtained either from the school direct or
                    by using the link (underneath each school) to access the
                    relevant website for more information.
                    <br/><br/>
                    {#each schools as s}
                      {#if s.warningText && s.warningText != ''}
                        <strong>
                          <p>
                          {s.schoolName}
                            <br />
                            {@html s.warningText}
                            {#if s.warningUrl && s.warningUrl != ''}
                              <br />
                              <a href={s.warningUrl} target="_blank">{s.warningUrl}</a>                            
                              <br/><br/>
                            {/if}
                          </p>
                        </strong>
                      {/if}
                    {/each}
                  </div>
                </div>
              </nav>
            {/if}
            <nav class="panel" style="margin-top: 15px;" tabindex="0">
              <div
                class="panel-heading"
                style="display: flex;align-items: stretch;font-size: inherit;">
                <strong>Child details</strong>
              </div>
              <div class="panel-block">
                <div class="column">Child name</div>
                <div class="column">
                  <strong>
                    {details.application.Forename}
                    {details.application.MiddleName ? details.child.MiddleName : ''}
                    {details.application.Surname}
                  </strong>
                </div>
              </div>
              <div class="panel-block">
                <div class="column">Address</div>
                <div class="column">
                  <strong>
                    {@html address.formattedAddress}
                  </strong>
                </div>
              </div>
              {#if details.application.councilTaxRef && details.application.councilTaxRef != ''}
                <div class="panel-block">
                  <div class="column">Council tax account number</div>
                  <div class="column">
                    <strong>{details.child.councilTaxRef}</strong>
                  </div>
                </div>
              {/if}
              <div class="panel-block">
                <div class="column">Date of birth</div>
                <div class="column">
                <strong>{dateToWords(details.application.DOB)}</strong>
                </div>
              </div>
              <div class="panel-block">
                <div class="column">Sex</div>
                <div class="column">
                  <strong>{getGenderDetails(details.application.Sex)}</strong>
                </div>
              </div>
              <div class="panel-block">
                <div class="column">Multiple births</div>
                <div class="column">
                  <strong>
                    {#if details.application.MultipleBirth && details.application.MultipleBirth == '1'}
                      Yes
                    {:else}No{/if}
                  </strong>
                </div>
              </div>
              {#if details.application.LookedAfter}
                <div class="panel-block">
                  <div class="column">
                    Child is in the care of or has previously been in the care of {details.application.LookedAfter.LaDisplayName}
                  </div>
                </div>
              {/if}
              {#if details.application.EHCPlan == '1'}
                <div class="panel-block">
                  <div class="column">Child has an EHCP</div>
                </div>
              {/if}
                {#if details.application.CurrentSchool && details.application.CurrentSchool.currentSchool}
                <div class="panel-block">
                  <div class="column">Child is currently attending</div>
                    <div class="column">
                    <strong>
                      {details.application.CurrentSchool.currentSchool.name}
                    </strong>
                      <br />
                      {#each details.application.CurrentSchool.currentSchool.address.split(',') as addr}
              {addr}<br/>
            {/each}
                  </div>
                </div>
              {/if}
               {#if laAnswers != ''}
        {#each laAnswers.split(';') as list}
          <div class="panel-block">
            <div class="column">{list.split('=')[0]}</div>
            <div class="column">
              <strong>{list.split('=')[1]}</strong>
            </div>
          </div>
        {/each}
      {/if}
              <div class="panel-block">
                <div class="column">Number of schools applied</div>
                <div class="column">
                  <strong>{selectedPrefs} out of {details.maxPreference}</strong>
                </div>
              </div>
            </nav>
            <nav class="panel" style="margin-top: 15px;" tabindex="0">
              <div
                class="panel-heading"
                style="display: flex;align-items: stretch;font-size: inherit;">
                <strong>Your details</strong>
              </div>
              <div class="panel-block">
                <div class="column">Name</div>
                <div class="column">
                  <strong>
                    {applicant.Title} {applicant.Forename} {applicant.Surname}
                  </strong>
                </div>
              </div>
              <div class="panel-block">
                <div class="column">Relationship</div>
                <div class="column">
                  <strong>
                    {RelationshipOptions.find(r => r.value == applicant.ContactRelationship).label}
                  </strong>
                </div>
              </div>
              <div class="panel-block">
                <div class="column">Parental Responsibility</div>
                <div class="column">
                  <strong>
                    {#if applicant.Responsibility == '1'}Yes{:else}No{/if}
                  </strong>
                </div>
              </div>

              <div class="panel-block">
                <div class="column">Address</div>
                <div class="column">
                  <strong>
                    {#if applicant.Address.AddressAsPupil && applicant.Address.AddressAsPupil == '1'}
                      {@html address.formattedAddress}
                    {:else if applicantAddress != null}
                      {@html applicantAddress.formattedAddress}
                    {/if}
                  </strong>
                </div>
              </div>
              {#each applicantPhones as phones}
              {#if phones.TelephoneType == 'W'}
                <div class="panel-block">
                  <div class="column">Work number</div>
                  <div class="column">
                    <strong>{phones.PhoneNo}</strong>
                  </div>
                </div>
              {/if}
              {#if phones.TelephoneType == 'H'}
                <div class="panel-block">
                  <div class="column">Home number</div>
                  <div class="column">
                    <strong>{phones.PhoneNo}</strong>
                  </div>
                </div>
              {/if}
              {#if phones.TelephoneType == 'M'}
                <div class="panel-block">
                  <div class="column">Mobile number</div>
                  <div class="column">
                    <strong>{phones.PhoneNo}</strong>
                  </div>
                </div>
              {/if}
              {/each}
              {#if applicant.Email && applicant.Email != ''}
                <div class="panel-block">
                  <div class="column">Email</div>
                  <div class="column">
                    <strong>{applicant.Email}</strong>
                  </div>
                </div>
              {/if}
              {#if details.application.CrownService && details.application.CrownService == '1'}
                <div class="panel-block">
                  <div class="column">In Crown Service</div>
                  <div class="column">
                    <strong>Priority Requested</strong>
                  </div>
                </div>
              {/if}

              {#if applicant.AlternativeContactNotes && applicant.AlternativeContactNotes != ''}
                <div class="panel-block">
                  <div class="column">Second contact name</div>
                  <div class="column">
                    <strong>
                      {getSecondContactFirstName(applicant.AlternativeContactNotes)}
                      {getSecondContactSurName(applicant.AlternativeContactNotes)}
                    </strong>
                  </div>
                </div>

                <div class="panel-block">
                  <div class="column">Second contact relationship</div>
                  <div class="column">
                    <strong>
                      {getSecondContactRelation(applicant.AlternativeContactNotes)}
                    </strong>
                  </div>
                </div>
              {/if}
            </nav>
            {#each Object.keys(details.application.Preferences) as prefKey}
              <nav class="panel" style="margin-top: 15px;" tabindex="0" >

                <div
                  class="panel-heading"
                  style="display: flex;align-items: stretch;font-size: inherit;">
                  <strong>
                    {ordinal(details.application.Preferences[prefKey].PreferenceRank)}
                    School Preference
                  </strong>
                </div>

                <div class="panel-block">
                  <div class="column">Address</div>
                  <div class="column">
                    <strong>
                      {details.application.Preferences[prefKey].school.schoolName}
                    </strong>
                      <br />
                      {@html details.application.Preferences[prefKey].school.addressDetails}
                  </div>
                </div>
                {#if details.application.Preferences[prefKey].SupportingInformation.Sibling}
                  <div class="panel-block">
                    <div class="column">Sibling name</div>
                    <div class="column">
                      
                        {details.application.Preferences[prefKey].SupportingInformation.Sibling.Forename}
                        {details.application.Preferences[prefKey].SupportingInformation.Sibling.MiddleName ? details.application.Preferences[prefKey].SupportingInformation.Sibling.MiddleName : ''}
                        {details.application.Preferences[prefKey].SupportingInformation.Sibling.Surname}
                      
                    </div>
                  </div>
                  <div class="panel-block">
                    <div class="column">Sibling address</div>
                    <div class="column">
                      
                        {#if details.application.Preferences[prefKey].SupportingInformation.Sibling.Address.AddressAsPupil && details.application.Preferences[prefKey].SupportingInformation.Sibling.Address.AddressAsPupil == '1'}
                        {@html address.formattedAddress}
                        {:else}
                        {@html details.application.Preferences[prefKey].SupportingInformation.Sibling.Address.BS7666Address.formattedAddress}
                        {/if}
                      

                    </div>
                  </div>
                  <div class="panel-block">
                    <div class="column">Sibling date of birth</div>
                    <div class="column">
                    
                        {parseDate(details.application.Preferences[prefKey].SupportingInformation.Sibling.DOB)}
                      
                    </div>
                  </div>

                  <div class="panel-block">
                    <div class="column">Sex of sibling</div>
                    <div class="column">
                      
                        {getGenderDetails(details.application.Preferences[prefKey].SupportingInformation.Sibling.Sex)}
                      
                    </div>
                  </div>

                   <div class="panel-block">
                    <div class="column">Sibling school</div>
                    <div class="column">
                      
                       {#if details.application.Preferences[prefKey].SupportingInformation.Sibling.linkedSchoolName}
                       {details.application.Preferences[prefKey].SupportingInformation.Sibling.linkedSchoolName}
                       {:else}
                       {details.application.Preferences[prefKey].school.schoolName}
                       {/if}
                      
                    </div>
                  </div>
                  {/if}
                  {#if details.application.Preferences[prefKey].school.staffChild == 'Y' || details.application.Preferences[prefKey].school.staffChild == '1'}
                    <div class="panel-block">
                      <div class="column">Staff Member</div>
                      <div class="column">Priority Requested</div>
                    </div>
                    <div class="panel-block">
                      <div class="column">Staff members name</div>
                      <div class="column">{details.application.Preferences[prefKey].school.stafffname} {details.application.Preferences[prefKey].school.stafflname}</div>
                    </div>
                  {/if}
                  {#if isYes(details.application.Preferences[prefKey].school.medical)}
                    <div class="panel-block">
                      <div class="column">Medical reason</div>
                      <div class="column">Priority Requested</div>
                    </div>
                  {/if}
                  {#if isYes(details.application.Preferences[prefKey].school.social)}
                    <div class="panel-block">
                      <div class="column">Social reason</div>
                      <div class="column">Priority Requested</div>
                    </div>
                  {/if}
                     {#if details.application.Preferences[prefKey].SupportingInformation.ReasonText}
                    <div class="panel-block">
                      <div class="column">Additional reason</div>
                      <div class="column">{ details.application.Preferences[prefKey].SupportingInformation.ReasonText}</div>
                    </div>
                  {/if}
                  {#if details.application.Preferences[prefKey].school.information && details.application.Preferences[prefKey].school.information != ''}
                    <div class="panel-block">
                      <div class="column">Important school information</div>
                      <div class="column">
                        {@html details.application.Preferences[prefKey].school.information}
                      </div>
                    </div>
                  {/if}
                  {#if details.application.Preferences[prefKey].school.warningText && details.application.Preferences[prefKey].school.warningText != ''}
                    <div class="panel-block">
                      <div class="column">Supplementary information form</div>
                      <div class="column">
                        {@html details.application.Preferences[prefKey].school.warningText}
                      </div>
                    </div>
                  {/if}               
              </nav>
            {/each}

          </div>
        </div>
      </div>
    </div>
  </section>

{/await}
{/if}
